import Vue from 'vue'
import Vuex from 'vuex'
import {official} from "@/api/backend";

Vue.use(Vuex)

const defaultBasicInfo={
  "address": "苏州工业园区仁爱路99号西郊科创园D2栋513",
  "beian_no": "苏ICP备2023005553号",
  "company_name": "苏州良秉信息科技有限公司",
"worktime": "9:30-17:30"
}

const state = {
  basicInfo: {

  },
}


export default new Vuex.Store({
  state,
  actions: {
    async getBasicInfo(context) {
      official().then(({data})=>{
        if(data.code!=0){
          //使用备用数据
          localStorage.setItem("INFO",JSON.stringify(defaultBasicInfo))
          context.commit("setBasicInfo",defaultBasicInfo)
          return;
        }

        localStorage.setItem("INFO",JSON.stringify(data.data))
        context.commit("setBasicInfo",data.data)

      }).catch(error=>{
        console.log(error)
        localStorage.setItem("INFO",JSON.stringify(defaultBasicInfo))
        context.commit("setBasicInfo",defaultBasicInfo)
      })
    },
    deleteBasicInfo(context){
      localStorage.removeItem("INFO")
    }
  },
  mutations: {
    setBasicInfo(state, data) {
      state.basicInfo = data
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js